__turbopack_context__.v({
  "clearButton": "searchBar-module-scss-module__QunIFW__clearButton",
  "dropdown": "searchBar-module-scss-module__QunIFW__dropdown",
  "emptyState": "searchBar-module-scss-module__QunIFW__emptyState",
  "emptyStateHint": "searchBar-module-scss-module__QunIFW__emptyStateHint",
  "emptyStateQuery": "searchBar-module-scss-module__QunIFW__emptyStateQuery",
  "emptyStateTitle": "searchBar-module-scss-module__QunIFW__emptyStateTitle",
  "highlight": "searchBar-module-scss-module__QunIFW__highlight",
  "input": "searchBar-module-scss-module__QunIFW__input",
  "inputContainer": "searchBar-module-scss-module__QunIFW__inputContainer",
  "popularSearchChip": "searchBar-module-scss-module__QunIFW__popularSearchChip",
  "popularSearches": "searchBar-module-scss-module__QunIFW__popularSearches",
  "popularSearchesList": "searchBar-module-scss-module__QunIFW__popularSearchesList",
  "popularSearchesTitle": "searchBar-module-scss-module__QunIFW__popularSearchesTitle",
  "resultItem": "searchBar-module-scss-module__QunIFW__resultItem",
  "resultItemActive": "searchBar-module-scss-module__QunIFW__resultItemActive",
  "resultItemCategory": "searchBar-module-scss-module__QunIFW__resultItemCategory",
  "resultItemContent": "searchBar-module-scss-module__QunIFW__resultItemContent",
  "resultItemDescription": "searchBar-module-scss-module__QunIFW__resultItemDescription",
  "resultItemHeader": "searchBar-module-scss-module__QunIFW__resultItemHeader",
  "resultItemTitle": "searchBar-module-scss-module__QunIFW__resultItemTitle",
  "root": "searchBar-module-scss-module__QunIFW__root",
  "searchIcon": "searchBar-module-scss-module__QunIFW__searchIcon",
  "variant_fullscreen": "searchBar-module-scss-module__QunIFW__variant_fullscreen",
  "variant_header": "searchBar-module-scss-module__QunIFW__variant_header",
});
